module.exports = __webpack_public_path__ + "static/media/syndicate.35f4cc99.svg";